import { render, staticRenderFns } from "./search-result-type-product.vue?vue&type=template&id=7cc008bb&scoped=true&"
import script from "./search-result-type-product.vue?vue&type=script&lang=js&"
export * from "./search-result-type-product.vue?vue&type=script&lang=js&"
import style0 from "./search-result-type-product.vue?vue&type=style&index=0&id=7cc008bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc008bb",
  null
  
)

export default component.exports